import React, { PropsWithChildren } from "react";
import PropTypes from "prop-types";
import "./styles/index.scss";
import C from "../../../../constants";
import RemoveIcon from "../../icons/removeIcon";

const getClassName = (type, disabled: boolean, size) => {
  return `${type} ${disabled ? "disabled-" + type : ""} ${size}`;
};

const getLeftIcon = (itemLeft, type) => {
  switch (itemLeft) {
    case "remove":
    default:
      return (
        <RemoveIcon
          fill={(type === C.DESTRUCTIVE_TYPE_BUTTON && "#FF737E") || "#0000F5"}
          onClick={() => console.log(`onClick isn't implemented`)}
        />
      );
  }
};

export type ButtonProps = PropsWithChildren<{
  type?:
    | "primary"
    | "secondary"
    | "disabled-secondary"
    | "disabled-primary"
    | "ghost"
    | "destructive";
  modifier?: string;
  size?: "small" | "medium" | "medium-min" | "large";
  className?: string;
  itemLeft?: string;
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  id?: string;
}>;

const Button = ({
  type = "secondary",
  size = "large",
  className,
  itemLeft,
  disabled,
  children,
  onClick,
  id,
  ...props
}: ButtonProps) => {
  const handleClick = (e) => {
    if (
      [
        C.DISABLED_PRIMARY_TYPE_BUTTON,
        C.DISABLED_SECONDARY_TYPE_BUTTON,
      ].indexOf(type) > -1
    ) {
      return;
    }
    onClick(e);
  };

  return (
    <button
      id={id}
      type="button"
      disabled={disabled}
      onClick={handleClick}
      className={`${getClassName(type, disabled, size)} ${className}`}
      {...props}
    >
      {itemLeft && getLeftIcon(itemLeft, type)}
      <span>{children}</span>
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  onClick: () => undefined,
};

export default Button;
